import { Component, OnInit } from '@angular/core';
import { ModalController} from '@ionic/angular';
import { ContactsImportPage } from '../contacts-import/contacts-import.page';

import { Capacitor } from '@capacitor/core';

import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";

import { Business } from '../models/business';

import { ApiService } from '../services/api.service';

import { Router } from '@angular/router';

@Component({
  selector: 'app-business-create',
  templateUrl: './business-create.page.html',
  styleUrls: ['./business-create.page.scss'],
})
export class BusinessCreatePage implements OnInit {

  isNativePlatform = true;
  ionicForm: UntypedFormGroup;
  isSubmitted = false;

  constructor(public modalCtrl: ModalController, public formBuilder: UntypedFormBuilder, public apiService: ApiService, public router: Router) { }

  ngOnInit() {
    this.isNativePlatform = Capacitor.isNativePlatform();

    // Build Business Form
    this.ionicForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')]],
      phone1: [''],
      address1: [''],
      address2: [''],
      city: [''],
      postcode: ['']
    })
  }

  dismiss() {  
    this.modalCtrl.dismiss();
  }

  private prepareSave(): Business {
    return new Business().deserialize(this.ionicForm.value);
  }

  submitForm() {
    this.isSubmitted = true;

    if (!this.ionicForm.valid) {
      console.log('Please provide all the required values for a business.')
      console.log(this.ionicForm);
      return false;
    } else {
      console.log(this.ionicForm.value)

      // Save contact information
      const newBusiness = this.prepareSave(); // `newBusiness` is now an instance of "Business"

      // API Call
      this.apiService.createBusiness(newBusiness).subscribe((business) => {
        console.log(business);
        
        //this.router.navigateByUrl('/t/contacts/view/'+contact.id);
        
      });

      // Close the modal
      this.modalCtrl.dismiss(this.ionicForm.value); // TODO: Return data, although we should refresh previous view / form
    }
  }

  get errorControl() {
    return this.ionicForm.controls;
  }

}